import { useTheme, Theme } from '@mui/material/styles'

export default function useColor() {
  const theme = useTheme<Theme>()

  const getColor = (colorPath: string): string | undefined => {
    const keys = colorPath.split('.')

    // Walk the object safely with indexed access
    let current: unknown = theme.palette

    for (const key of keys) {
      if (typeof current === 'object' && current !== null && key in current) {
        current = (current as Record<string, unknown>)[key]
      } else {
        return undefined
      }
    }

    // If it's a color object with a `.main` property
    if (typeof current === 'object' && current !== null && 'main' in current) {
      const main = (current as { main: unknown }).main
      return typeof main === 'string' ? main : undefined
    }

    // Otherwise, if it's just a color string
    return typeof current === 'string' ? current : undefined
  }

  return getColor
}
